<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-buffer"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row>
        <v-col cols="12" class="white rounded-lg">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="fieldDetail.name"
                    filled
                    label="Name"
                    placeholder="Nhập tên field project"
                    @keyup="onKeyUp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="fieldDetail.slug"
                    filled
                    label="Slug"
                    placeholder="Nhập tên slug"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <div class="my-4">Description</div>
                <ck-content :content="fieldDetail.description" class="ck-project"
                            @getData="value => fieldDetail.description = value"></ck-content>
              </v-col>
              <v-col cols="12">
                <v-file-input
                    v-model="image"
                    label="Ảnh"
                    placeholder="Tải ảnh lên"
                    prepend-icon="mdi-camera"
                    @change="uploadImg"
                ></v-file-input>
                <v-img :class="[display_image ? 'mb-8':'d-none']"
                       :src="display_image? display_image :''" aspect-ratio="1.7"
                       contain
                ></v-img>
              </v-col>
            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="fieldDetail.name_vi"
                    filled
                    label="Tên"
                    placeholder="Nhập tên field project"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-row>
                  <v-col cols="8">
                    <v-text-field
                        v-model="fieldDetail.order"
                        filled
                        label="Vị trí"
                        placeholder="Nhập vị trí"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3">
                    <v-checkbox
                        v-model="selected"
                        label="Active"
                    ></v-checkbox>
                  </v-col>
                </v-row>

              </v-col>
              <v-col cols="12">
                <div class="my-4">Mô tả</div>
                <ck-content :content="fieldDetail.description_vi" class="ck-project"
                            @getData="value => fieldDetail.description_vi = value"></ck-content>
              </v-col>
            </v-col>
          </v-row>


          <v-col cols="12" align="center">
            <v-btn
                color="primary"
                width="180"
                @click="save()"
            >
              Lưu
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import {
  GET_DETAIL_FIELD_PROJECT,
  UPDATE_FIELD_PROJECT,
  UPLOAD_IMAGE
} from "@/store/modules/field_project";
import {mapGetters} from "vuex";
import CkContent from "@/components/ck-content";
import validateSlug from "@/mixins/validateSlug";

export default {
  name: "Add_new_feildProject",
  components: {
    CkContent
  },
  mixins: [validateSlug],
  data() {
    return {
      page: "Sửa loại project",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách loại project",
          disabled: true,
        },
        {
          text: "Sửa loại project",
          disabled: false,
        },
      ],

      image: null,
      display_image: '',
      url: '',
      selected: '',
      slug: ''
    }
  },
  computed: {
    ...mapGetters({
      fieldDetail: "fieldDetail",
    }),
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_DETAIL_FIELD_PROJECT, this.$route.params.id);

  },
  watch: {
    fieldDetail(val) {
      if (val && val.photo_url) {
        this.display_image = this.url + val.photo_url;

      }
      if (val && val.active) {
        this.selected = val.active
      }
    }
  },
  methods: {
    onKeyUp(value) {
      this.fieldDetail.slug = this.sanitizeTitle(value.target.value)
    },
    uploadImg(e) {
      if (!e) {
        this.display_image = "";
        this.fieldDetail.photo_url = "";
      }
      this.display_image = URL.createObjectURL(e)
      this.$forceUpdate()
    },

    async save() {
      if (this.image != null) {
        let formDateAvatar = new FormData();
        formDateAvatar.append("upload", this.image);
        formDateAvatar.append("type", "ckeditor");
        formDateAvatar.append("position_type", "1");
        await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
              if (data.data.status == 1) {
                this.fieldDetail.photo_url = data.data.data[0].path
              }
            }
        )
      }
      this.fieldDetail.active = this.selected ? '1' : '0'
      await this.$store.dispatch(`${UPDATE_FIELD_PROJECT}`, this.fieldDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/project_management/field_project')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }
}
</script>

<style scoped>

</style>